// simple version of the function
export const formatDateByLocale = (mdat, locale) => {
    if ((mdat !== '') && (mdat !== null) && (locale.length === 5)) {
        // Locale: en-GB of nl-NL
        return new Date(mdat).toLocaleDateString(locale, {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    } else {
        return '';
    }
};

/**
 * get a textual presentation of a calendar date (without year)
 * @param mdat format: mmdd
 * @param locale
 * @returns {string}
 */
export const formatDayOfMonthByLocale = (mdat, locale) => {
    if ((mdat !== '') && (mdat !== null) && (locale.length === 5)) {
        // if we get mm-dd instead of mmdd we need to remove that -
        mdat = mdat.replace('-', '');
        let retDate = '';
        if (mdat.substring(2) === '00') {
            // put an arbitrary year in there
            mdat = '2018-' + mdat.substring(0, 2) + '-01';
            // Locale: en-GB of nl-NL
            retDate = new Date(mdat).toLocaleDateString(locale, {
                month: 'long'
            });
        } else {
            // put an arbitrary year in there
            mdat = '2018-' + mdat.substring(0, 2) + '-' + mdat.substring(2);
            // Locale: en-GB of nl-NL
            retDate = new Date(mdat).toLocaleDateString(locale, {
                day: 'numeric',
                month: 'short'
            });
        }
        return retDate;
    } else {
        console.log("no locale or mdat");
        return mdat;
    }
};
